import { SetupAuth } from "../../client";
import { displayError, displaySuccess } from "../../utils/messageToast";

/** Mesma origem do botão "Gerar payload": POST `/create-payload` com alias + clientId + ambient. */
export async function fetchCreatePayload(
  clientId: string,
  authorization: string,
  ambient: string,
  alias: string
): Promise<unknown | undefined> {
  try {
    const apiClient = SetupAuth(authorization);
    const response = await apiClient.post(
      `/create-payload?alias=${encodeURIComponent(
        alias
      )}&clientId=${encodeURIComponent(clientId)}&ambient=${encodeURIComponent(
        ambient
      )}`
    );
    return response.data?.payload;
  } catch {
    return undefined;
  }
}

export const generatePayload = async (
  setLoadingButtonGeneratePayload: React.Dispatch<
    React.SetStateAction<boolean>
  >,
  clientId: string,
  authorization: string,
  ambient: string,
  alias: string
) => {
  try {
    setLoadingButtonGeneratePayload(true);
    const payload = await fetchCreatePayload(
      clientId,
      authorization,
      ambient,
      alias
    );
    if (payload === undefined) {
      displayError("Erro ao gerar payload!");
      return;
    }
    navigator.clipboard.writeText(JSON.stringify(payload, null, 2));
    displaySuccess("Payload copiado para a área de transferência!");
    return payload;
  } finally {
    setLoadingButtonGeneratePayload(false);
  }
};
